export default __webpack_public_path__ + "static/michele-f5fa8eba27ca33c360eec4e1f3ebc139.png";